import CssBaseline from '@mui/material/CssBaseline';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import type {FC} from 'react';
import {createRoot} from 'react-dom/client';
import Routes from './routes';
import theme from './theme';
import './i18n';

const App: FC = () => (
  <ThemeProvider theme={theme()}>
    <CssBaseline />
    <Routes />
  </ThemeProvider>
);

const container = document.getElementById('app');
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}

export default App;
